import React from 'react';
import { Common } from '../../utils/common';

/**
 * @typedef {{ label: string, value: string | number }} Data
 *
 * @param {Object} props
 * @param {string} [props.href] - Optional href value to link to.
 * @param {string} props.title - Title header of the widget.
 * @param {'chat'
 *       | 'call'
 *       | 'prospects'
 *       | 'appointments'
 *       | 'visitors'
 *       | 'outboundcalls'
 *       | 'lead'
 *       | 'text'} props.color - String corresponding to the color variable in report_details.css.scss.
 * @param {Data | Data[]} props.data - Data to display in the widget. Can pass in a single data
 *     point or an array of data points.
 */
export default function CountWidget({ href, title, color, data }) {
  // Links should not work in crm mode or in a scheduled report
  const shouldDisableLink = Common.in_crm_mode() || window.IN_SCHEDULED_REPORT_MODE || !href;
  // Transform data into an array if only one data point is passed in so map can be used
  const dataArray = Array.isArray(data) ? data : [data];

  return (
    <a
      href={shouldDisableLink ? undefined : href}
      className={`count-widget ${shouldDisableLink ? 'btn-non-clickable' : ''}`}
    >
      <h4 className='count-widget-title'>{title}</h4>
      <div className='count-widget-content'>
        {dataArray.map(({ label, value }) => (
          <div key={label} className='count-widget-column'>
            <div className={`count-widget-total ${color}-total`}>{value}</div>
            <div className='count-widget-subtitle'>{label}</div>
          </div>
        ))}
      </div>
      <div className={`count-widget-underline ${color}-underline`} />
    </a>
  );
}
